import { GridColDef } from '@mui/x-data-grid';

export const betGameSettingListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 300,
    field: 'name',
    headerName: 'name',
    sortable: false,
    headerAlign: 'center',
    align: 'center',
  },

  {
    minWidth: 10,
    field: 'type',
    headerName: 'type',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'totAmountName',
    headerName: '누적 베팅금액',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'jackpotAmountName',
    headerName: '잭팟 금액',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'jackpotReadyName',
    headerName: '잭팟 준비금',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
];

export const betUserLedgerListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: '지갑 주소',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'amount',
    headerName: '수량',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'status',
    headerName: '상태',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    flex: 1,
    minWidth: 200,
    field: 'memo',
    headerName: 'memo',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const jackpotListColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: '지갑 주소',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'amount',
    headerName: '잭팟 금액',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },

  {
    minWidth: 200,
    field: 'regDt',
    headerName: '등록일',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const winHistoryColumns: GridColDef[] = [
  {
    flex: 1,
    minWidth: 200,
    field: 'address',
    headerName: '지갑주소',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'totalBet',
    headerName: '누적 베팅액',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'betAmount',
    headerName: '베팅금',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'winAmount',
    headerName: '당첨금',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'jackpotPayout',
    headerName: '잭팟 지급금',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'jackpotReserve',
    headerName: '잭팟 준비금',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'smallWinAmount',
    headerName: '소액당첨',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'referralAmount',
    headerName: '레퍼럴 운영',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'burnAmount',
    headerName: '소각금액',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'winMultiple',
    headerName: '당첨 배수',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'regDt',
    headerName: '일시',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];
